<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          @click="productPopup()"
        >新增产品</el-button>
        <!-- <el-button
          type="info"
        >批量删除</el-button> -->
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip
          effect="dark"
          content="刷新列表"
          placement="bottom"
        >
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="productName"
        label="产品名称"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.productName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="categoryName"
        label="所属分类"
        show-overflow-tooltip
      > </el-table-column>
      <el-table-column
        prop="productType"
        label="产品类别"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.productType | productTypeName }}</template>
      </el-table-column>
      <el-table-column
        prop="productState"
        label="产品状态"
        align="center"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.productState === 1">
            <el-tag type="success">在产</el-tag>
          </template>
          <template v-else>
            <el-tag type="danger">停产</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="specification"
        label="产品规格"
      > </el-table-column>
      <el-table-column
        prop="shelfLife"
        label="保质期"
        align="center"
      > </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="productPopup(scope.row.id)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="productDel(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 新增产品 -->
    <el-drawer
      title=""
      :visible.sync="drawer"
      :with-header="false"
      size="85%"
    >
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>产品管理&nbsp;&nbsp;<span style="color:red;font-size: small;">*先保存产品信息，再进行产品配置和溯源配置</span></span>
        </h2>
      </div>
      <el-divider class="margin-0"></el-divider>
      <div style="padding:20px;">
        <el-tabs
          v-if="showTab"
          v-model="activeName"
          type="card"
        >
          <el-tab-pane
            label="基本信息"
            name="first"
          >
            <AddForm
              ref="basic"
              :id="productID"
              @cancel="drawer = false"
              @success="getdProductID"
              @paneStatus="getPaneStatus"
              :is-edit="isEdit"
            />
          </el-tab-pane>
          <el-tab-pane
            label="产品配置"
            name="second"
            :disabled="isPaneDisabled"
            lazy
          >
            <ProductConfig :id="productID" />
          </el-tab-pane>
          <el-tab-pane
            label="溯源配置"
            name="third"
            :disabled="isPaneDisabled"
            lazy
          >
            <ProductTemplate
              :templateOptions="templateOptions"
              :id="productID"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawerDetail" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawerDetail = false"></i>
          <span>产品详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">产品名称</td>
            <td>{{ detailDate.productName }}</td>
            <td class="list-item">产品商标</td>
            <td>{{ detailDate.productTrademark }}</td>
          </tr>
          <tr>
            <td class="list-item">商品条码</td>
            <td>{{ detailDate.barcode }}</td>
            <td class="list-item">保质期</td>
            <td>{{ detailDate.shelfLife }}</td>
          </tr>
          <tr>
            <td class="list-item">一级分类</td>
            <td>{{ detailDate.categoryLevelName1 }}</td>
            <td class="list-item">二级分类</td>
            <td>{{ detailDate.categoryLevelName2 }}</td>
          </tr>
          <tr>
            <td class="list-item">三级分类</td>
            <td>{{ detailDate.categoryLevelName3 }}</td>
            <td class="list-item">四级分类</td>
            <td>{{ detailDate.categoryLevelName4 }}</td>
          </tr>
          <tr>
            <td class="list-item">产品规格</td>
            <td>{{ detailDate.specification }}</td>
            <td class="list-item"></td>
            <td></td>
          </tr>
          <tr>
            <td class="list-item">产品图片</td>
            <td colspan="3" class="list-item-imgs">
              <img :src="detailDate.imgUrl1">
              <img :src="detailDate.imgUrl2">
              <img :src="detailDate.imgUrl3">
              <img :src="detailDate.imgUrl4">
              <img :src="detailDate.imgUrl5">
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import AddForm from './components/AddForm'
import ProductConfig from './components/ProductConfig'
import ProductTemplate from './components/ProductTemplate'
import { getTraceTemplateList } from '@/api/tracetemplate'
import { getProductList, deleteProductDel, getProductDetail } from '@/api/product'

export default {
  components: {
    AddForm,
    ProductConfig,
    ProductTemplate
  },
  data() {
    return {
      activeName: 'first',
      drawer: false,
      showTab: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      parentID: null,
      productID: null,
      isDisabled: false,
      isPaneDisabled: true,
      loading: true,
      selectionID: [],
      tableData: [],
      detailDate: {},
      drawerDetail: false,
      templateOptions: [],
      isEdit: false
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)

    getTraceTemplateList({
      page: 1,
      size: 1000
    }).then(res => {
      const { total, rows } = res.data
      this.templateOptions = rows

      if (total > 1000) {
        getTraceTemplateList({
          page: 1,
          size: total
        }).then(res => {
          this.templateOptions = res.data.rows
        })
      }
    })
  },
  watch: {
    drawer(val) {
      if (val === false) {
        this.$nextTick(() => {
          this.showTab = false
        })
      }
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getProductListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getProductListData()
    },
    getPaneStatus(v) {
      console.log(v)
      this.isPaneDisabled = v
    },
    // 删除产品
    productDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteProductDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除产品成功')
              this.getProductListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 打开表单
    productPopup(id) {
      this.activeName = 'first'
      this.isEdit = !!id
      this.productID = id || null
      this.showTab = true

      this.$nextTick(() => {
        this.drawer = true
      })
    },
    // 获取子组件传来的ID
    getdProductID(id) {
      if (this.productID !== id) {
        this.productID = id
        this.getProductListData()
      }
    },
    // 检索
    search() {
      this.getProductListData()
    },
    // 刷新数据表格
    refresh() {
      this.getProductListData()
      this.$message.success('数据刷新成功')
    },
    // 详情
    detailShow(id) {
      this.drawerDetail = true
      getProductDetail(id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取产品列表
    getProductListData() {
      this.loading = true
      getProductList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getProductListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    // 产品类别：1:初级农产品、0:加工品
    productTypeName(value) {
      const map = { 1: '初级农产品', 0: '加工品' }
      return map[value] !== undefined ? map[value] : value
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-0 {
  margin: 0!important;
}
</style>
